const api = (function() {
    const CACHE = {
        straps: null,
        buckles: null
    };

    // 通过 Ajax 获取产品数据（/products/handle.js 返回完整变体，无需认证，无20条限制）
    async function fetchProduct(handle) {
        const response = await fetch(`/products/${handle}.js`);
        if (!response.ok) throw new Error(`fetch ${handle} failed: ${response.status}`);
        return response.json();
    }

    // 将 Ajax 变体格式化为统一格式
    // metafields 优先从 window.__strapMeta / __buckleMeta 查找（Liquid 注入），否则从 options 推断
    function formatVariant(v, optionNames, metaMap) {
        let metafields = {};

        if (metaMap && metaMap[v.id]) {
            // 使用 Liquid 注入的完整 metafields（含 strap_material、strap_color 等）
            metafields = metaMap[v.id];
        } else {
            // 回退：从 option 名称推断 metafields
            [v.option1, v.option2, v.option3].forEach((val, i) => {
                if (val && optionNames[i]) {
                    metafields[optionNames[i].toLowerCase().replace(/\s+/g, '_')] = val;
                }
            });
        }

        return {
            id: String(v.id),
            sku: v.sku || '',
            title: v.title,
            price: v.price / 100,
            image: v.featured_image ? v.featured_image.src : '',
            altText: v.title,
            inventory: v.inventory_quantity || 0,
            available: v.available,
            metafields
        };
    }

    async function getStraps() {
        if (CACHE.straps) return CACHE.straps;
        
        // 优先使用 Liquid 注入的完整变体数据
        if (window.__strapVariants && Array.isArray(window.__strapVariants) && window.__strapVariants.length > 0) {
            CACHE.straps = window.__strapVariants;
            return CACHE.straps;
        }
        
        // 通过 Ajax 获取
        try {
            const handle = window.builderSettings?.strapProductHandle || 'custom-belt-straps';
            const product = await fetchProduct(handle);
            const optionNames = product.options.map(o => o.name);
            const metaMap = window.__strapMeta || null;
            CACHE.straps = product.variants.map(v => formatVariant(v, optionNames, metaMap));
            return CACHE.straps;
        } catch (e) {
            console.error('Failed to fetch straps:', e);
            return [];
        }
    }

    async function getBuckles() {
        if (CACHE.buckles) return CACHE.buckles;
        
        // 优先使用 Liquid 注入的完整变体数据
        if (window.__buckleVariants && Array.isArray(window.__buckleVariants) && window.__buckleVariants.length > 0) {
            CACHE.buckles = window.__buckleVariants;
            return CACHE.buckles;
        }
        
        // Liquid 数据为空，通过 Ajax 获取
        try {
            const handle = window.builderSettings?.buckleProductHandle || 'custom-belt-buckles';
            const product = await fetchProduct(handle);
            
            CACHE.buckles = product.variants.map(v => ({
                id: String(v.id),
                sku: v.sku || '',
                title: v.title,
                price: v.price / 100,
                image: v.featured_image ? v.featured_image.src : '',
                altText: v.title,
                inventory: v.inventory_quantity || 0,
                available: v.available,
                metafields: {
                    buckle_type: 'Pin Buckles',
                    buckle_material: v.option1 || '',
                    buckle_specification: v.option2 || '',
                    buckle_width: null,
                    buckle_color: null,
                    buckle_technology: null,
                    buckle_thickness: null
                }
            }));
            
            return CACHE.buckles;
        } catch (e) {
            console.error('Failed to fetch buckles:', e);
            return [];
        }
    }

    function clearCache() {
        CACHE.straps = null;
        CACHE.buckles = null;
    }

    function isCached(type) {
        return CACHE[type] !== null;
    }

    return { getStraps, getBuckles, clearCache, isCached, _cache: CACHE };
})();
